import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MDBDataTable } from "mdbreact";
import _ from "lodash";
import "./styles.css";
import * as FileSaver from 'file-saver';
import LoadingOverlay from "react-loading-overlay";

import Util from '../../../Common/util';
import API from '../../../Common/api';
import styled, { css } from "styled-components";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;




var url = window.location.hostname;
var port = window.location.port;
var From_Date_val ;
var to_Date_val;
var Packed_From_Date_val;
var Packed_to_Date_val;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Warehouse', 'Client', 'Bill No.', "Bill Date", 'Prod Code', 'Product Name', 'MRP', 'UPC', 'Order Qty', 'Dispatch Confirmed', 'Handover Completed', 'Total Value', 'Tax Amount', 'Tax %', 'Taxable Value', 'Retailer Name', 'Retailer Code', 'Invoice Amount']];
  const ws = XLSX.utils.json_to_sheet(csvData, { origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.getCookie = this.getCookie.bind(this);


    this.accessCookie = this.accessCookie.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.downloadError= this.downloadError.bind(this);

    this.state = {

      filtered_orderData: "",
      warehouse_code: "",
      warehouseData: [],
      clientData: [],
      brand_code: "",

      loader1: false,
      // showVariant: false,
      isDisabledApply: false,

      fromdate: "",
      todate: "",
      packedfromdate:"",
      packedtodate:"",

      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      bill_no: "",
      group_id: "",
    };
  }

  onBillChange = (evt) => {
    this.setState({
      bill_no: evt.target.value,
    });
  };

  onGroupChange = (evt) => {
    this.setState({
      group_id: evt.target.value,
    });
  };


  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {

    this.setState({
      fromdate: date,
      showFromErr: false,
      packedfromdate: "",
      packedtodate:"",

    })
    if (date) {
      From_Date_val = this.convertDate(date);
      Packed_From_Date_val = "";
      Packed_to_Date_val = "";
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = "";
      Packed_From_Date_val = "";
      Packed_to_Date_val = "";
    }


  }

  ToDateChange = date => {
    
    this.setState({
      todate: date,
      showToErr: false,
      packedfromdate: "",
      packedtodate:"",
    })
    if (date) {
      to_Date_val = this.convertDate(date);
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    } else {
      this.setState({
        todate: "",

      })
      to_Date_val = "";
      Packed_From_Date_val = "";
    Packed_to_Date_val = "";
    }

  }
  PackedFromDateChange = date => {
   
    this.setState({
      packedfromdate: date,
      showFromErr: false,
      fromdate:"",
      todate : "",

    })
    if (date) {
      Packed_From_Date_val = this.convertDate(date);
      From_Date_val = "";
      to_Date_val = "";
    } else {
      this.setState({
        packedfromdate: ""
      })
      Packed_From_Date_val = "";
      From_Date_val = "";
      to_Date_val = "";
    }


  }

  PackedToDateChange = date => {

    this.setState({
      packedtodate: date,
      showToErr: false
    })
    if (date) {
    Packed_to_Date_val = this.convertDate(date);
    From_Date_val = "";
      to_Date_val = "";
    } else {
      this.setState({
        pakcedtodate: "",

      })
      Packed_to_Date_val = "";
      From_Date_val = "";
      to_Date_val = "";
    }

  }

  componentDidMount() {
    this.fetchWarehouseData();
    this.fetchBrandData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var today = new Date();
    From_Date_val = this.convertDate(today);
    to_Date_val = this.convertDate(today);

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        // fromdate: today,
        // todate: today,
        // packedfromdate : today,
        // packedtodate : today,

      },
      () => {

      }
    );

  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  assembleDispatchData = (dispatchData) => {

    let DispatchData = dispatchData.map((post, index) => {

      return {
        warehouse: post.warehouse,
        client: post.client,
        outlet_order_no: post.outlet_order_no,
        bill_date: post.bill_date,
        sku7_code: post.sku7_code,
        product_name: post.product_name,
        mrp: post.mrp,
        upc: post.upc,
        order_qty: post.order_qty,
        dispatch_confirmed: post.dispatch_confirmed,
        handover_completed: post.handover_completed,
        total_value: post.total_value,
        tax_amount: post.tax_amount,
        tax_percentage: post.tax_percentage,
        taxable_value: post.taxable_value,
        retailer_name: post.retailer_name,
        retailer_code: post.retailer_code,
        invoice_amount: post.invoice_amount,

      };
    });

    this.setState({
      orderData: DispatchData,
      filtered_orderData: DispatchData,
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };

  onwarehouseChange = (evt) => {

    this.setState({
      warehouse_code: evt.target.value
    })

  }

  onBrandChange = (evt) => {

    this.setState({
      brand_code: evt.target.value
    })

  }


  fetchWarehouseData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchDispatch = (order_no) => {

    this.setState({
      loading_overlay: true,
      //loading: true,
    });

    // var batch = localStorage.getItem('batch_id');
    const payload = {
      "request_type": "view",
      "group_id": this.state.group_id,
      "to_date": to_Date_val,
      "from_date": From_Date_val,
      "packed_from_date" : Packed_From_Date_val,
      "packed_to_date" : Packed_to_Date_val,
      "bill_number": this.state.bill_no,
      "warehouse": this.state.warehouse_code,
      "brand": this.state.brand_code

    };

    API.post('/mis/uploaded-dispatch-report/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.success == false) {
          this.setState({
            failed_message: data.message
          })
          this.toggle();
        }


        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          //return false;
        }



        this.setState({
          // orderData: data.data,
          // filtered_orderData: data.data,
          tableRowsMap: this.assembleDispatchData(data.data),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function (error) { });
  };
  downloadError = (order_no) => {

    this.setState({
      loading_overlay: true,
      //loading: true,
    });

    // var batch = localStorage.getItem('batch_id');
    const payload = {
      "request_type": "download",
      "group_id": this.state.group_id,
      "to_date": to_Date_val,
      "from_date": From_Date_val,
      "packed_from_date" : Packed_From_Date_val,
      "packed_to_date" : Packed_to_Date_val,
      "bill_number": this.state.bill_no,
      "warehouse": this.state.warehouse_code,
      "brand": this.state.brand_code

    };

    API.post('/mis/uploaded-dispatch-report/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.success == false) {
          this.setState({
            failed_message: data.message
          })
          this.toggle();
        }
        if (data.success == true) {
          window.location.href = data.data[0]
          this.setState({
            loading_overlay: false,
          })
          
        }

        if (data.length == 0) {

          this.setState({
            dispatch_status: true,
            showFetchDispatchData: true,
            loading_overlay: false,
            loading: false,

          });
          //return false;
        }
        
      })
      .catch(function (error) { });
  };
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData });
    } else {

      var value = this.state.orderData.filter(
        (val) => {
          return Object.keys(val).some(key => {
            var data = ""
            if (val[key] == null) {
              data = ""
            }
            else {
              data = val[key]
            }

            return data.toString().toLowerCase().includes(evt.toLowerCase())
          })
        }
      );

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  render() {
    const { handleSubmit, reset, t } = this.props;

    const dispatchData = {
      columns: [
        {
          label: "Warehouse",

          field: "warehouse",
          width: 120,
        },
        {
          label: "Client",

          field: "client",
          width: 120,
        },
        {
          label: "Bill No.",

          field: "outlet_order_no",
          width: 120,
        },
        {
          label: "Bill Date",

          field: "bill_date",
          width: 120,
        },
        {
          label: "Prod Code",

          field: "sku7_code",
          width: 120,
        },
        {
          label: "Prod Name",

          field: "product_name",
          width: 140,
        },
        {
          label: "MRP",

          field: "mrp",
          width: 90,
        },
        {
          label: "UPC",

          field: "upc",
          width: 110,
        },


        {
          label: "Order Qty",

          field: "order_qty",
          width: 100,
        },

        {
          label: "Dispatch Confirmed",

          field: "dispatch_confirmed",
          width: 130,
        },

        {
          label: "Handover Completed",

          field: "handover_completed",
          width: 130,
        },

        {
          label: "Total Value",

          field: "total_value",
          width: 110,
        },
        {
          label: "Tax Amount",
          field: "tax_amount",
          width: 140,
          sort: 'asc'
        },
        {
          label: " Tax %",
          field: "tax_percentage",
          width: 140,
          sort: 'asc'
        },

        {
          label: "Taxable Value",
          field: "taxable_value",
          width: 140,
          sort: 'asc'
        },

        {
          label: "Retailer Name",
          field: "retailer_name",
          width: 140,
          sort: 'asc'
        },
        {
          label: "Retailer Code",
          field: "retailer_code",
          width: 140,
          sort: 'asc'
        },
        {
          label: "Invoice Amount",
          field: "invoice_amount",
          width: 140,
          sort: 'asc'
        }


      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>

        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody style={{ paddingTop: 5, height: 145, paddingBottom: 0 }}>
            <form className="form" onSubmit={handleSubmit}>

            <div style={{ marginBottom: '5px', float: 'left', marginRight: 10, border: "1px solid rgba(0, 0, 0, 0.125)",borderRadius : "4px"}}>
            <p style={{marginLeft:5}}>SO Creation Date</p>
              <div style={{  marginBottom: '5px', float: 'left', marginRight: 8, marginLeft:5}}>
                
                <DatePicker
                  selected={this.state.fromdate}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'
                />
                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
              <div style={{ marginBottom: '5px', float: 'left', marginRight: 5, }}>
                <DatePicker
                  selected={this.state.todate}
                  onChange={this.ToDateChange}
                  className="ledger_todate"
                  styles ={{height: '36px!important'}}
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
              </div>
              <div style={{marginRight: 8,marginTop: 22}}>
                <p>OR</p>
              </div>
              <div style={{ marginBottom: '10px', float: 'left', marginRight: 10, border: "1px solid rgba(0, 0, 0, 0.125)",borderRadius : "4px"}}>
            <p style={{marginLeft:5}}>Packed Date</p>
              <div style={{  marginBottom: '5px', float: 'left', marginRight: 5, marginLeft:5}}>
                
                <DatePicker
                  selected={this.state.packedfromdate}
                  onChange={this.PackedFromDateChange}
                  className="ledger_fromdate"
                  placeholderText="From Date"
                  format='yyyy-MM-dd'
                />
                {this.state.showFromErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                }
              </div>
              <div style={{ marginBottom: '5px', float: 'left', marginRight: 5, }}>
                <DatePicker
                  selected={this.state.packedtodate}
                  onChange={this.PackedToDateChange}
                  className="ledger_todate"
                  styles ={{height: '36px!important'}}
                  placeholderText="To Date"
                />
                {this.state.showToErr &&
                  <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
                }
              </div>
              </div>
              
              <div style={{ marginBottom: '15px', float: 'left', marginRight: 10, }}>
              <div
                style={{ marginBottom: '0px', width: '214px',float: 'left', marginRight: 10, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Enter Group" onChange={this.onGroupChange} />
                </div>
              </div>
              
              <div
                style={{width: '204px', marginBottom: '0px', float: 'left', marginRight: 35 }}
              >
                <div
                  className="form__form-group-field"

                >
                  <input type="text" style={{ height: 38 }} className="form-control" placeholder="Enter Bill No" onChange={this.onBillChange} />
                </div>
              </div>
              
              <div
                style={{ marginBottom: '0px', float: 'left', marginRight: 5, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 214 }}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>


              <div
                style={{  width:'205px',marginBottom: '0px', float: 'left', marginRight: 10, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>


              <div style={{ marginBottom: '0px', float: 'left' ,marginRight: 15}}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch(this.state.order_no)}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>

              <div style={{  marginBottom: '0px', float: 'left' }}>
                <Button type="button" className="btn btn-primary-outline"
                  style={{
                    cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                    backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                  }}
                  id="button_enable"
                onClick={this.downloadError}
                >

                  <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} />
                  {/* <img src={require('../../../../images/download.png')} onClick={(e) => exportToCSV(this.state.filtered_orderData, "SO To Dispatch Report")} /> */}
                </Button>
              </div>
              </div>
            </form>
          </CardBody>
          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -5 }}
              >
                <MDBDataTable
                  scrollX
                  scrollY
                  sortable={false}
                  maxHeight="390px"
                  displayEntries={false}
                  striped
                  onSearch={this.filterData}
                  bordered
                  data={dispatchData}
                />
              </div>
            </CardBody>
          )}
        </Card>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
